<template>
<div>
    <!-- <TheNavigationPanel/> -->
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="50" >
            <v-toolbar-title style="color:#62AE32" class="headline">View Consultant</v-toolbar-title>
        </v-toolbar> 
             <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
                  <span>Role updated successfully.</span> 
                     <v-btn text color="white" @click="snackbar = false">Close</v-btn>
                </v-snackbar>   
        <v-row justify="center" class="mt-n4">
            <v-avatar size="120" v-for="user in Images" :key="user.id">
                <v-img class="" :src="getImgUrl(user.profile_img_url)" lazy-src="/account.png"></v-img>
            </v-avatar>
        </v-row> 
       
        <div class="mt-6">
            <v-card class="mx-auto" color="#F0FFEA" max-width="400" flat> 
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Name</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label=""
                            readonly
                            solo
                            flat
                            dense
                            v-model="name"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Consultant Id</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="clientId"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Email</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="email"
                            style="font-size:14px"
                            class="black-text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Phone Number</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="contact"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Admin</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="role"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <!-- <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">D.O.B</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="dob"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row> -->
            </v-card>
        </div>
         <v-row justify="center" class="mt-3">
             <v-dialog persistent v-model="dialog" max-width="300px">
                <template v-slot:activator="{ on }">
                    <v-btn large color="#08911B" class="pa-3 mt-3" width="200" dark style="border-radius:20px" v-on="on">
                        <span>Update Role</span>
                    </v-btn> 
                </template>
                <v-card>
                    <v-card-title>
                    <span class=" black--text">Update Role</span>
                    </v-card-title>

                    <v-card-text>
                    <v-container>
                        <v-checkbox
                            v-model="checkAdmin"
                            label="Admin"
                            color="#62AE32"
                        ></v-checkbox>
                                         
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#62AE32" text @click="save">CANCEL</v-btn>
                    <v-btn color="#62AE32" :loading="loading" text @click="close">UPDATE</v-btn>
                    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
    </v-container>

</div>
   
</template>
<script>
    // import TheNavigationPanel from '../components/TheNavigationPanel';

    export default {
        name: 'viewConsultant',
        components: {
            // TheNavigationPanel,
        },

        data: () => ({
            dialog:false,
            loading: false,
            name:"Adeleke Abiodun",
            clientId:"90121",
            email:"",
            contact:"09087658907",
            role:"No",
            status:"Active",
            policyStatus:'',
            checkAdmin: '',
            type: "role",
            snackbar: false,
            // url:"http://192.168.1.105:3000"
            // url:"https://cover-my-car.herokuapp.com"
            url:"https://res.cloudinary.com/dmnghlyic/image/upload/v1587481342/"
            
           
        }),
         computed:{
            Images(){
                return this.$store.state.consultants.consultantbyid
             }
        },
        methods:{ 
            save(){
                this.dialog=false
            },
            close(){
                this.loading= true
                this.$store.dispatch("UpdateRole",{
                    "consultantUsername": this.$store.state.consultants.consultantbyid[0].consultant_id,
                    "type": this.type
                })
                .then((success)=>{
                    console.log(success)
                    this.loading = false
                    this.snackbar = true
                    this.dialog=false
                    alert(this.$store.state.consultants.consultantbyid[0].id)
                    this.$store.dispatch("ConsultantById", this.$store.state.consultants.consultantbyid[0].id)
                    .then((success)=>{
                    console.log(success)
                    this.$router.push(`/consultants/viewConsultant/${this.$store.state.consultants.consultantbyid[0].firstname}`);
                    })
                    .catch((error)=>{
                        console.log(error);
                    })
                        })
                .catch((error)=>{
                    console.log(error)
                })
            },
             getImgUrl(pic) {
                if(pic==="" || pic===null){
                    let image="/account.png"
                    return image
                }else{
                    let weblink = this.url + "/files/images/";
                    return weblink+pic;
                }
                 
                
            },
        },
        created(){
             this.name = this.$store.state.consultants.consultantbyid[0].name
             this.clientId = this.$store.state.consultants.consultantbyid[0].consultant_id
             this.email = this.$store.state.consultants.consultantbyid[0].email
             this.contact = this.$store.state.consultants.consultantbyid[0].phone_number
             this.dob = this.$store.state.consultants.consultantbyid[0].dob.slice(0, 19).replace('T', ' ')
             if(this.$store.state.consultants.consultantbyid[0].is_Admin == 1){
                 this.checkAdmin = true
                 this.role = "Yes"
             }  
            
        },

        

    }
</script>